/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { keyResultHealthResponseSchema } from './keyResultHealthResponseSchema';

export const keyResultHealthByIdsResponseSchema = z.object({
  get data() {
    return z.array(keyResultHealthResponseSchema);
  },
});
